import React, { useContext } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { DashboardContext } from '../../context/DashboardContext';
import moment from 'moment';
import 'moment/locale/fa';
import avatarImage from "../../assets/images/users/avatar-1.jpg"

const RecentComment = () => {
  const { recentComments } = useContext(DashboardContext);

  return (
    <React.Fragment>
      <div className="col-xl-4">
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">نظرات اخیر</h4>
            <div className="flex-shrink-0">
              <Button color="soft-primary" size="sm">مشاهده همه</Button>
            </div>
          </CardHeader>
          <CardBody>
            <SimpleBar data-simplebar className="mx-n3 px-3" style={{ height: '375px' }}>
              <div className="vstack gap-3">
                {recentComments.map((item, idx) => (
                  <div className="d-flex gap-3" key={idx}>
                    <img
                      src={avatarImage}
                      alt=""
                      className="avatar-sm rounded flex-shrink-0"
                    />
                    <div className="flex-grow-1">
                      <h6 className="mb-2">
                        {item.senderName} <span className="text-muted">نظری ارسال کرده</span>
                      </h6>
                      <p className="text-muted mb-1" title={item.message}>
                        {item.message.length > 100 ? item.message.substring(0, 100) + '...' : item.message}
                      </p>
                      <small className="text-muted">
                        {moment(item.createdAt).locale('fa').format('DD MMMM YYYY, HH:mm')}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            </SimpleBar>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default RecentComment;